<template>
    <v-app>
      <Drawer current_item="menu_package"></Drawer>
      
      <v-main class="ml-6 mr-6">
        <v-card
              class="mx-auto mt-4 mr-6 pa-6"
              outlined
            >
                <v-card-title> {{ $t('package_title') }}</v-card-title>
                <v-divider></v-divider>
                <v-data-table
                    :headers="headers"
                    :items-per-page="10"
                    :items="items"
                >
                    <template v-slot:top >
                        <v-toolbar flat color="white">
                                <v-spacer></v-spacer>
                                <DlgPackage ref="dlgPackage" @onCloseDialog="onCloseDialog"></DlgPackage>
                        </v-toolbar>
                    </template>
                    <template  v-slot:[`item.action`]="{ item }">
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                        >
                            edit
                        </v-icon>
                        <v-icon
                            small
                            @click="deleteItem(item)"
                        >
                            delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
      </v-main>
      <v-snackbar
            v-model="snackbar"
            timeout="2000"
     >
      {{ message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    </v-app>
</template>

<script>
import Drawer from '@/components/Drawer.vue'
import config from '@/../config.js'
import DlgPackage from './DlgPackage'
import axios from 'axios';
import Staff from '@/model/instance/Staff.js'

export default {
  name: 'Package',
  computed: {
    headers() {
      return [
            {text: this.$t('package_code'), value: 'package_code', width: '40%'},
            {text: this.$t('package_name'), value: 'package_name', width: '40%'},
            {text: 'Actions', value: 'action', sortable: false}
        ]
    }
  },
  components: {
      Drawer,
      DlgPackage
  },
  data: () => ({
      items: [],
      editedIndex: -1,
      snackbar: false,
      message: ''
  }),
  methods: {
      loadPackage() {
        var que = this.$store.commit('addLoading')
        axios.get(
            config.api.url.manage.package.list_package,
            { headers: Staff.getTokenHeader()}
        ).then(rs => {
            this.$store.commit('finishLoading',que)
            this.items = rs.data;
        })
        .catch(error => {
            this.$store.commit('finishLoading',que)
            this.$router.push({name:'Error',params:error}) 
        });
      },
      editItem(item) {
          this.editedIndex = this.items.indexOf(item);
          this.$refs.dlgPackage.show(Object.assign({}, item));
      },
      deleteItem(item) {
          var que = this.$store.commit('addLoading')
          axios.get(
            config.api.url.manage.package.delete_package + item.package_id,
            { headers: Staff.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.editedIndex = this.items.indexOf(item);
            this.items.splice(this.editedIndex, 1);
            this.editedIndex = -1;
        })
      },
      onCloseDialog(isSuccess) {
          if (isSuccess == true) {
              this.loadPackage();
              this.message = this.$t('save_success');
              this.snackbar = true;
          }
          
          this.editedIndex = -1;
      }
  },
  mounted() {
      this.loadPackage();
  }
}
</script>